export default function groupFormEntries(entries: any[]) {
  const groupedArray: { string: Array<string> } = entries
    .reduce((acc, [name, value]) => {
      (acc[name] = acc[name] || []).push(value);
      return acc;
    }, {});

  const groupedObject = Object.entries(groupedArray)
    .map(([key, value]) => [key, value.join(',')])
    .reduce((acc: { [index: string]: string }, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return groupedObject;
}
